export enum RatingStatus {
    None = 0,
    Active = 1, //LIVE
    Archived = 2,
    Internal = 3,
    WaitingActivation = 4, //APPROVED
    PendingReview = 5 //NEW
}